import React from "react";
import { Modal, Spin } from "antd";
import AppIcon from "components/ui/AppIcon.jsx"

const AppModal = ({
  open,
  onClose,
  title,
  width = 560,
  children,
  footer,
  titleAlign = "start",
  className = "app-modal",
  zIndex,
  maskStyle,
  loading = false,
  ...restProps
}) => {
  const getTitleAlignmentClass = () => {
    switch (titleAlign) {
      case "center":
        return "text-center";
      case "start":
      default:
        return "text-left";
    }
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={footer ?? null}
      centered
      width={width}
      closable
      maskClosable
      className={className}
      zIndex={zIndex}
      maskStyle={maskStyle}
      closeIcon={<AppIcon name="remove" size={28} />}
      {...restProps}
    >
      <Spin spinning={loading}>
      {title && (
        <h2 className={`text-20px font-semibold mb-5 ${getTitleAlignmentClass()}`}>
          {title}
        </h2>
      )}

      {children}
      </Spin>
    </Modal>
  );
};

export default AppModal;
